
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^([345678]|15)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
